export default "__VITE_ASSET__BjOLwGsI__"